import { connect } from 'react-redux';
import { getHotelFAQ, getHotelName } from 'src/routes/Hotel/store/hotel';
import { getIsMobile } from 'src/store/view/selectors';
import { HotelFAQ } from './HotelFAQ';

const mapStateToProps = (state) => ({
  hotelName: getHotelName(state),
  questions: getHotelFAQ(state),
  isMobile: getIsMobile(state),
});

const connector = connect(mapStateToProps);

export default connector(HotelFAQ);
